export default __webpack_public_path__ + "static/media/shape3.0e7266bd.svg";